<template>
    <md-dialog
    md-dynamic-height
    v-on:md-opened="initDialog"
    class="message-action"
    :md-active.sync="show">
        <md-toolbar class="md-primary">
            <h3>Текущая заявка решена и закрыта</h3>
        </md-toolbar>
        <md-progress-bar v-if="inProcess" md-mode="indeterminate"></md-progress-bar>
        <div v-if="!ratingOnly" class="radio-container">
            <md-radio v-model="action" value="rate">Поставить оценку специалисту</md-radio>
            <md-radio v-model="action" value="open" :disabled="activeTicket != null">Открыть текущую заявку</md-radio>
            <md-radio v-model="action" value="show" :disabled="activeTicket == null">Показать открытую заявку
                {{activeTicket ? `№${activeTicket.ticketNumber} от ${activeTicket.ticketCreateTime.substring(0, activeTicket.ticketCreateTime.lastIndexOf(":"))}` : ""}}</md-radio>
            <md-radio v-if="false" v-model="action" value="create">Создать новую заявку</md-radio>
        </div>
        <div class="md-card extra-container" v-if="action == 'rate' || action == 'open' || ratingOnly">
            <rating-control v-if="action == 'rate' || ratingOnly" v-model="rating"/>
            <div v-if="action == 'open' && !activeTicket">
                <div class="reason-container">
                    <md-radio v-for="reason in openReasons" v-model="openReason" :key="reason" :value="reason">{{openReasonDescription(reason)}}</md-radio>
                </div>
                <md-field>
                    <label>Минимум 10 символов</label>
                    <md-textarea class="open-reason-comment" v-model="openReasonComment">
                    </md-textarea>
                </md-field>
            </div>
        </div>
        <md-dialog-actions>
            <md-button :disabled="!okEnabled() || inProcess" @click="doAction()" class="md-primary md-raised">
                Ок
            </md-button>
            <md-button :disabled="this.inProcess" class="md-accent md-raised" @click="show = false;">
                Отмена
            </md-button>
        </md-dialog-actions>
    </md-dialog>
</template>
<script>
import ratingControl from './ratingControl.vue';

import axios from "axios";
import {mapGetters} from "vuex";

export default {
  components: { ratingControl },
    name: "TicketMessageAction",
    props: {
        isVisible: Boolean,
        ticket: Object,
        ratingOnly: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        rating: {
            value: 0,
            text: ""
        },
        action: "",
        openReason: "",
        openReasons: ["unresolved", "new_facts"],
        openReasonComment: '',
        inProcess: false,
        activeTicket: null
    }),
    computed: {
        ...mapGetters([
            "LAST_NUMBER",
            "CURRENTAPTEKA",
            'USERID',
            'CURRENTUSER']),
        show: {
            get() {
                return this.isVisible;
            },
            set(val) {
                if (!val) {
                    this.$emit("hide-ticket-message-action");
                }
            }
        },
    },
    methods: {
        initDialog() {
            this.rating.value = 0;
            this.rating.text = "";
            this.action = this.ratingOnly ? "rate" : "";
            this.openReason = "";
            this.inProcess = false;
            this.openReasonComment = "";
            this.getActiveTicket();
        },
        okEnabled() {
            let rateValid = this.action == "rate" && this.rating.value != 0;
            let openValid = this.action == "open" && this.openReason != "" && this.openReasonComment.length >= 10;
            let createValid = this.action == "create";
            let showValid = this.action == "show" && this.activeTicket;
            return  rateValid || openValid || createValid || showValid;
        },
        openReasonDescription(reason) {
            if (reason == "unresolved") {
                return "Заявка не решена";
            }
            else if(reason == "new_facts") {
                return "Новые обстоятельства";
            }
            return "";
        },
        doAction() {
            this.inProcess = true;
            if (this.action == "create") {
                this.createTicket();
            }
            else if (this.action == "open") {
                this.openTicket(this.openReasonDescription(this.openReason));
            }
            else if (this.action == "rate") {
                this.rateTicket();
            }
            else if (this.action == "show") {
                this.showTicket();
            }
        },
        openTicket(reasonDescription) {
            let finishFunc = () => {
                this.inProcess = false;
                this.$emit("closed-ticket-open");
                this.show = false;
            }
            let messageText = `${reasonDescription}: ${this.openReasonComment}`;
            let params = {
                    ticketNumber: this.ticket.ticketId,
                    number: this.ticket.ticketNumber,
                    title: this.ticket.ticketTitle,

                    newMessage: messageText,
                    messageForMail: messageText,

                    clientNpp: this.CURRENTAPTEKA.npp,
                    userId: this.USERID,
                    idapt: this.CURRENTAPTEKA.idapt,

                    state: "close"
                };
                
            axios.post("data/saveMessage", JSON.stringify(params), {headers: {"Content-Type": "application/json"}}).then(
                (response) => {
                    finishFunc();
                },
                (error) => {
                    this.$store.dispatch("showSnackBar", { snackText: error });
                    finishFunc();
                }
			);
        },
        rateTicket() {
            let finishFunc = ()=> {
                this.inProcess = false;
                this.show = false;
                this.$emit('ticket-rated');
            }
            this.inProcess = true;
            let params = {
                    ticketNumber: this.ticket.ticketId,
                    number: this.ticket.ticketNumber,
                    title: this.ticket.ticketTitle,

                    newMessage: this.rating.text,
                    messageForMail: this.rating.text,
                    ratingValue: this.rating.value == 0 ? null : this.rating.value,

                    clientNpp: this.CURRENTAPTEKA.npp,
                    userId: this.USERID,
                    idapt: this.CURRENTAPTEKA.idapt,
                    
                    closeTicket: true
                };
            axios.post("data/saveMessage", JSON.stringify(params), {headers: {"Content-Type": "application/json"}}).then(
                (response) => {
                    finishFunc();
                },
                (error) => {
                    this.$store.dispatch("showSnackBar", { snackText: error });
                    finishFunc();
                }
			);
        },
        createTicket() {
            /*this.$store.dispatch("ADD_TABB", {
                        id: this.LAST_NUMBER,
                        Name: "Новая заявка",
                        Value: "newTicket",
                        Route: "newTicket",
                        Pagination: false
                    });
            this.$store.dispatch("SETNEWTABTICKETTITLEA", {
                            titleName: this.ticket.ticketTitle,
                            titleId: this.ticket.ticketTitleId
                        });
            this.$store.dispatch("INCREASE_LAST_NUMBER");
            this.$store.dispatch("SET_HASCREATETICKETTAB", true);
            this.$store.dispatch("SET_SUPPORTCURRENTTABROUTE", "newTicket");
            this.$router.push(
                {
                    path: "/support/newTicket"
                });*/
        },
        getActiveTicket() {
            this.$http.get("data/GetTicketsTitlesInfo", {
                    params: { npp: this.CURRENTAPTEKA.npp }
				}).then(resp => {
					let activeTicketsInfo = resp.body;
					for (let i = 0, cnt = activeTicketsInfo.length; i < cnt; i++) {
                        let ticket = activeTicketsInfo[i];
                        if (ticket.titleNpp == this.ticket.ticketTitleId && ticket.ticketId != -1) {
                            this.activeTicket = ticket;
                        }
					}
				})
        },
        showTicket() {
            this.$root.$emit('show-ticket', this.activeTicket.ticketNumber, this.activeTicket.ticketId);
            this.show = false;
        }
    }
}
</script>
<style lang="scss">
    .message-action {
        .md-dialog-container {
            height: auto;
            width: auto;
        }
         z-index: 1000;
    }
    .radio-container {
        display: flex;
        flex-direction: column;
        margin: 10px;
    }
    .rating-container {
        display: flex;
        flex-direction: row;
    }
    .extra-container {
        margin: 5px;
        padding: 5px;
        display: flex;
        flex-direction: column;
    }
    .reason-container {
        display: flex;
        flex-direction: column;
    }
    .open-reason-comment {
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// Components/supportNew/ticketMessageAction.vue